import { loyaltyPromotionSchema } from "@redotech/redo-loyalty-common/loyalty-definition";
import * as z from "zod";

export const getLoyaltyPromotions = {
  name: "getLoyaltyPromotions" as const,
  input: z.object({}),
  output: z.object({ loyaltyPromotions: z.array(loyaltyPromotionSchema) }),
};
